<ion-app>
    <mat-drawer-container class="h-100">
        <mat-drawer [(opened)]="isUserMenuOpened" position="end" mode="over">
            <nav class="sideNav wrapper" aria-label="User Menu">
                <div>
                    <a
                        href="javascript:void(0)"
                        class="closebtn"
                        (click)="toggleUserMenu()"
                        >&times;</a
                    >
                </div>
                <div class="sidebar-header"></div>
                <ul class="fa-ul list-unstyled components ms-0 pe-5 me-5 pt-5">
                    <li>
                        <a
                            class="activeLink"
                            [routerLink]="['/profile-overview']"
                            (click)="toggleUserMenu()"
                        >
                            <svg
                                version="1.1"
                                id="Ebene_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="35"
                                height="35"
                                viewBox="0 0 100 100"
                                style="enable-background: new 0 0 100 100"
                                xml:space="preserve"
                            >
                                <style type="text/css">
                                    .st0 {
                                        fill: none;
                                        stroke: currentColor;
                                        stroke-width: 3;
                                        stroke-miterlimit: 10;
                                    }
                                </style>
                                <path
                                    class="st0"
                                    d="M79.4,85.7c0-4.8-0.1-9.3,0-13.8c0.1-4.4-1.4-8.2-4.6-11c-2.5-2.2-5.5-3.9-8.3-5.8c-1.2-0.8-2.2-0.5-3.4,0.3c-7.8,4.9-15.8,5.3-23.8,0.7c-2.6-1.5-4.5-1.5-6.8,0c-1.6,1-3.2,2-4.7,3.2c-4.1,3.4-6.4,7.7-6.2,13.2c0.1,3.1,0,6.2,0,9.3v4H79.4z"
                                />
                                <path
                                    class="st0"
                                    d="M69,34.1c0,10.3-8.2,18.5-18.5,18.5c-10.2,0-18.6-8.3-18.5-18.5c0-10.2,8.3-18.5,18.6-18.5C60.8,15.6,69,23.8,69,34.1"
                                />
                            </svg>
                            <span class="ps-3">{{
                                "profile" | translate
                            }}</span>
                        </a>
                    </li>
                    <li>
                        <a
                            class="activeLink"
                            [routerLink]="['/myMachines']"
                            (click)="toggleUserMenu()"
                        >
                            <svg
                                viewBox="0 0 283.46 283.46"
                                style="enable-background: new 0 0 283.46 283.46"
                                width="35"
                                height="35"
                                style="padding: 2px"
                                xml:space="preserve"
                            >
                                <style type="text/css">
                                    .st1 {
                                        fill: none;
                                        stroke: currentColor;
                                        stroke-width: 8.5;
                                        stroke-miterlimit: 10;
                                    }
                                </style>
                                <polygon
                                    class="st1"
                                    points="176.88,107.07 270.29,115.86 196.88,174.29 217.38,265.84 139.13,214.08 58.39,261.87 83.44,171.45 13.04,109.44 106.77,105.32 144,19.2"
                                /></svg
                            ><span class="ps-3">{{
                                "myMachines" | translate
                            }}</span>
                        </a>
                    </li>
                    @if (
                        configuratorCountries.includes(params?.country?.code)
                    ) {
                        <li>
                            <a
                                class="activeLink"
                                [routerLink]="['/configurator']"
                                (click)="toggleUserMenu()"
                            >
                                <svg
                                    id="a"
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    width="35"
                                    height="35"
                                    style="padding: 3px"
                                    viewBox="0 0 189.2 189.2"
                                >
                                    <defs>
                                        <style>
                                            .st3 {
                                                fill: none;
                                                stroke-width: 4px;
                                                stroke: currentColor;
                                                stroke-linejoin: round;
                                                stroke-linecap: round;
                                                stroke-miterlimit: 10;
                                            }
                                        </style>
                                    </defs>
                                    <line
                                        class="st3"
                                        x1="54.7"
                                        y1="73.2"
                                        x2="101.2"
                                        y2="73.2"
                                    />
                                    <line
                                        class="st3"
                                        x1="115.5"
                                        y1="73.2"
                                        x2="134.5"
                                        y2="73.2"
                                    />
                                    <line
                                        class="st3"
                                        x1="54.7"
                                        y1="94.6"
                                        x2="67.8"
                                        y2="94.6"
                                    />
                                    <line
                                        class="st3"
                                        x1="81.6"
                                        y1="94.6"
                                        x2="134.5"
                                        y2="94.6"
                                    />
                                    <line
                                        class="st3"
                                        x1="54.7"
                                        y1="115.9"
                                        x2="89"
                                        y2="115.9"
                                    />
                                    <line
                                        class="st3"
                                        x1="102.9"
                                        y1="115.9"
                                        x2="134.5"
                                        y2="115.9"
                                    />
                                    <path
                                        class="st3"
                                        d="M154,95.2c-.4,33-27.7,59.8-60.3,59.2-32.9-.6-59.2-27.8-58.7-60.8.5-33.2,27.2-59,60.7-58.5,32.8.4,58.8,27.2,58.4,60.1"
                                    />
                                    <rect
                                        class="st3"
                                        x="102"
                                        y="67.1"
                                        width="12.2"
                                        height="12.2"
                                    />
                                    <rect
                                        class="st3"
                                        x="68.8"
                                        y="88.5"
                                        width="12.2"
                                        height="12.2"
                                    />
                                    <rect
                                        class="st3"
                                        x="89.3"
                                        y="109.8"
                                        width="12.2"
                                        height="12.2"
                                    />
                                    <path
                                        class="st3"
                                        d="M186.3,103.6c.3-3,.4-6,.4-9s-.1-5.4-.4-8l-13-1.5c-.9-7.3-2.7-14.3-5.5-20.9l10.6-7.7c-2.4-5.2-5.2-10.1-8.4-14.8l-12,5.2c-4.3-5.8-9.5-10.9-15.2-15.3l5.3-11.9c-4.6-3.3-9.5-6.2-14.7-8.6l-7.8,10.5c-6.5-2.8-13.5-4.7-20.8-5.7l-1.3-13c-3-.3-6-.4-9-.4s-5.4.1-8,.4l-1.5,13c-7.3.9-14.3,2.7-20.9,5.5l-7.7-10.6c-5.2,2.4-10.1,5.2-14.8,8.4l5.2,12c-5.8,4.3-10.9,9.5-15.3,15.2l-11.9-5.3c-3.3,4.6-6.2,9.5-8.6,14.7l10.5,7.8c-2.8,6.5-4.7,13.5-5.7,20.8l-13,1.3c-.3,3-.4,6-.4,9s.1,5.4.4,8l13,1.5c.9,7.3,2.7,14.3,5.5,20.9l-10.6,7.7c2.4,5.2,5.2,10.1,8.4,14.8l12-5.2c4.3,5.8,9.5,10.9,15.2,15.4l-5.3,11.9c4.6,3.3,9.5,6.2,14.7,8.6l7.8-10.5c6.5,2.8,13.5,4.7,20.8,5.7l1.3,13c3,.3,6,.4,9,.4s5.4-.1,8-.4l1.5-13c7.3-.9,14.3-2.7,20.9-5.5l7.7,10.6c5.2-2.4,10.1-5.2,14.8-8.4l-5.2-12c5.8-4.3,10.9-9.5,15.4-15.2l11.9,5.3c3.3-4.6,6.2-9.5,8.6-14.7l-10.5-7.8c2.8-6.5,4.7-13.5,5.7-20.8l13-1.3h0Z"
                                    /></svg
                                ><span class="ps-3">{{
                                    "myConfigurations" | translate
                                }}</span>
                            </a>
                        </li>
                    }
                    @if (canAccessAdmin()) {
                    <li>
                        <a
                            class="activeLink"
                            [routerLink]="['/admin']"
                            (click)="toggleUserMenu()"
                        >
                            <svg
                                width="35"
                                height="35"
                                viewBox="0 0 100 100"
                                xml:space="preserve"
                            >
                                <g
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                >
                                    <path d="M50,14 L82,27 L82,50 C82,70 68,82 50,88 C32,82 18,70 18,50 L18,27 Z" />
                                    <circle cx="50" cy="45" r="9" />
                                    <path d="M36,68 C36,58 44,54 50,54 C56,54 64,58 64,68" />
                                </g>
                            </svg>
                            <span class="ps-3">{{ "AdminArea" | translate }}</span>
                        </a>
                    </li>
                    }
                    <li>
                        <a
                            class="activeLink"
                            [routerLink]="['/logout']"
                            (click)="toggleUserMenu()"
                            (click)="logout()"
                        >
                            <svg
                                width="35"
                                height="35"
                                viewBox="0 0 100 100"
                                style="enable-background: new 0 0 100 100"
                                xml:space="preserve"
                            >
                                <style type="text/css">
                                    .st0 {
                                        fill: none;
                                        stroke: currentColor;
                                        stroke-width: 3;
                                        stroke-linecap: round;
                                        stroke-miterlimit: 10;
                                    }
                                </style>
                                <g>
                                    <path
                                        class="st0"
                                        d="M63.3,26.1C73.6,31,80.8,41.6,80.8,53.8c0,17-13.8,30.7-30.7,30.7S19.4,70.8,19.4,53.8c0-12.2,7.1-22.7,17.4-27.7"
                                    />
                                    <line
                                        class="st0"
                                        x1="50"
                                        y1="14.4"
                                        x2="50"
                                        y2="53.5"
                                    />
                                </g>
                            </svg>
                            <span class="ps-3">{{ "Logout" | translate }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </mat-drawer>
        <mat-drawer-content>
            <mat-drawer-container class="h-100">
                <!-- #region Sidenav on small displays -->
                <mat-drawer
                    [(opened)]="isMobileMenuOpened"
                    mode="over"
                    position="start"
                >
                    <nav class="sideNav wrapper" aria-label="Mobile Menu">
                        <button
                            type="menu"
                            class="closebtn btn btn-link"
                            (click)="toggleMobileMenu()"
                        >
                            &times;
                        </button>
                        <poe-mobile-menu-item
                            [title]="'goToProducts' | translate"
                            [routerLink]="['/machinesearch']"
                            (click)="toggleMobileMenu()"
                            (keydown.enter)="toggleMobileMenu()"
                        ></poe-mobile-menu-item>
                        @if (
                            configuratorCountries.includes(
                                params?.country?.code
                            )
                        ) {
                            <poe-mobile-menu-item
                                [title]="'configurator' | translate"
                                [routerLink]="['/configurator']"
                                (click)="toggleMobileMenu()"
                                (keydown.enter)="toggleMobileMenu()"
                            ></poe-mobile-menu-item>
                        }
                        <poe-mobile-menu-item
                            [title]="'machineAdvisor' | translate"
                        >
                            <poe-mobile-menu-item
                                [layer]="2"
                                [title]="'webbasedVersion' | translate"
                            >
                                <poe-mobile-menu-item
                                    [layer]="3"
                                    icon="assets/menu-icons/metering-wheel-assist.svg"
                                    title="METERING WHEEL ASSIST"
                                    (click)="onClickPoetsem()"
                                    (keydown.enter)="onClickPoetsem()"
                                ></poe-mobile-menu-item>
                                @if (
                                    params?.country?.code?.split("_")[1] !== "US"
                                ) {
                                    <poe-mobile-menu-item
                                        [layer]="3"
                                        icon="assets/menu-icons/tramline-assist.svg"
                                        title="TRAMLINE ASSIST"
                                        [routerLink]="['tramline-assist']"
                                        (click)="toggleMobileMenu()"
                                        (keydown.enter)="toggleMobileMenu()"
                                    >
                                    </poe-mobile-menu-item>
                                }
                                <poe-mobile-menu-item
                                    [layer]="3"
                                    icon="assets/menu-icons/haytool-assist.svg"
                                    title="HAYTOOL ASSIST"
                                    [routerLink]="['haytool-assist']"
                                    (click)="toggleMobileMenu()"
                                    (keydown.enter)="toggleMobileMenu()"
                                >
                                </poe-mobile-menu-item>
                                <poe-mobile-menu-item
                                    [layer]="3"
                                    icon="assets/menu-icons/row-crop-assist.svg"
                                    title="ROW CROP ASSIST"
                                    [routerLink]="['row-crop-assist']"
                                    (click)="toggleMobileMenu()"
                                    (keydown.enter)="toggleMobileMenu()"
                                >
                                </poe-mobile-menu-item>
                            </poe-mobile-menu-item>
                            <poe-mobile-menu-item
                                [layer]="2"
                                [title]="'mobileApps' | translate"
                            >
                                @for (appInfo of appInfos; track appInfo) {
                                    <poe-mobile-menu-item
                                        [layer]="3"
                                        [icon]="appInfo.icon"
                                        [title]="appInfo.name"
                                        (click)="openAppPopup(appInfo)"
                                        (keydown.enter)="openAppPopup(appInfo)"
                                    >
                                    </poe-mobile-menu-item>
                                }
                            </poe-mobile-menu-item>
                        </poe-mobile-menu-item>
                        <poe-mobile-menu-item
                            [title]="'contact' | translate"
                            [routerLink]="['/contact']"
                            (click)="toggleMobileMenu()"
                            (keydown.enter)="toggleMobileMenu()"
                        ></poe-mobile-menu-item>
                        <poe-mobile-menu-item
                            title="FAQs"
                            [routerLink]="['/faqs']"
                            (click)="toggleMobileMenu()"
                            (keydown.enter)="toggleMobileMenu()"
                        >
                        </poe-mobile-menu-item>
                    </nav>
                </mat-drawer>
                <!-- #endregion -->
                <mat-drawer-content>
                    <div
                        class="app-content flex-1 d-flex overflow-y-auto flex-column"
                        layout="column"
                        style="
                            min-height: 100%;
                            min-height: -webkit-fill-available;
                        "
                        layout-fill
                    >
                        <app-titlebar
                            [user]="user$ | async"
                            [appLinks]="appInfos"
                            [viewMode]="viewMode()"
                            (mobileMenuToggled)="toggleMobileMenu()"
                            (userMenuToggled)="toggleUserMenu()"
                        ></app-titlebar>
                        <poe-notification-tray></poe-notification-tray>
                        <div style="flex: 1 1 auto; display: contents">
                            <div
                                class="container-routes"
                                style="display: flex; flex-direction: column"
                            >
                                <router-outlet />
                            </div>
                            @if (
                                viewMode() !== "kiosk" &&
                                !router.url.startsWith("/configurator/")
                            ) {
                                <app-footer
                                    class="mt-auto"
                                    style="margin-top: 50px !important"
                                ></app-footer>
                            }
                        </div>
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </mat-drawer-content>
    </mat-drawer-container>
</ion-app>
